/**
 * SHAR-584/585/580/576 — how an airport and an aircraft category are written in
 * the admin panel.
 *
 * Routes read as ICAO plus city and country everywhere else in the product; the
 * charter screens were showing bare IATA codes. The API resolves the ICAO code,
 * city and country (charters.service.resolveAirports), so this is only the
 * presentation of what it returns.
 *
 * Degrades one step at a time: with no country it shows code and city, with
 * neither it shows the code alone, so a missing reference never renders "undefined".
 */
export function airportLabel(
  code?: string | null,
  city?: string | null,
  country?: string | null,
): string {
  if (!code) return '—';
  const place = [city, country].filter(Boolean).join(', ');
  return place ? `${code} - ${place}` : code;
}

/**
 * SHAR-576 — aircraft categories arrive as raw enum values ("very_light_jet")
 * and were printed as-is. Written out for people here.
 */
export function formatCategory(category?: string | null): string {
  if (!category) return '—';
  return category
    .replace(/_/g, ' ')
    .replace(/\b\w/g, (c) => c.toUpperCase());
}
